"use client"

import { LEO_DEEP_FILL_CLASS, LeoIcon } from "@/components/ui/leo-icon"
import { cn } from "@/lib/utils"

export function LeoSourceMark({
  source,
  className,
}: {
  source: "bank" | "created"
  className?: string
}) {
  if (source === "created") {
    return (
      <span
        className={cn(
          "inline-flex items-center gap-1.5 text-xs font-medium text-foreground",
          LEO_DEEP_FILL_CLASS,
          className,
        )}
        aria-label="By Leo AI"
      >
        <LeoIcon variant="ambient" size="xs" state="answered" />
        <span>By Leo AI</span>
      </span>
    )
  }

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 text-xs font-medium text-muted-foreground",
        className,
      )}
      aria-label="Your Bank"
    >
      <i className="fa-light fa-books text-xs" aria-hidden />
      <span>Your Bank</span>
    </span>
  )
}
